import script from "./subjectDetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./subjectDetailPage.vue?vue&type=script&setup=true&lang=js"

import "./subjectDetailPage.vue?vue&type=style&index=0&id=1aac7c68&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1aac7c68"]])

export default __exports__